import { z } from "zod";
import { ColorTokenData } from "./color";
import { tokenAliasOrValue } from "./base";
import { nullishToOptional } from "../../../helpers";
import { Point2D } from "../primitives";

export const GradientType = z.enum(["Linear", "Radial", "Angular"]);

export const GradientStop = z.object({
  position: z.number(),
  color: ColorTokenData,
});

export const GradientLayerValue = z.object({
  from: Point2D,
  to: Point2D,
  type: GradientType,
  aspectRatio: nullishToOptional(z.number()), // z.number(),
  stops: z.array(GradientStop).min(2),
});

export const GradientLayerData = tokenAliasOrValue(GradientLayerValue);

export const GradientTokenValue = z.array(GradientLayerData);
export const GradientTokenData = tokenAliasOrValue(GradientTokenValue);

export type GradientType = z.infer<typeof GradientType>;
export type GradientStop = z.infer<typeof GradientStop>;
export type GradientLayerValue = z.infer<typeof GradientLayerValue>;
export type GradientLayerData = z.infer<typeof GradientLayerData>;
export type GradientTokenValue = z.infer<typeof GradientTokenValue>;
export type GradientTokenData = z.infer<typeof GradientTokenData>;
